import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { ToastService } from '../../shared/toast.service';
import { LoaderService } from '../../shared/loader.service';

@Component({
  selector: 'app-platinum-page',
  templateUrl: './platinum-page.component.html',
  styleUrls: ['./platinum-page.component.scss']
})
export class PlatinumPageComponent {
   isLoading = false;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private toastService: ToastService,
    private loaderService: LoaderService
  ) {}

  platinumCards = [
    {
      img: '../../../assets/platinumPage/cards/1.png',
      head: 'Two-Year Access to NexGen Executive Coaching Academy AI-Driven LMS Platform',
      para: 'Interactive training modules',
      para2: 'Knowledge checks and coaching simulations'
    },
    {
      img: '../../../assets/platinumPage/cards/2.png',
      head: 'On-Demand Executive Coaching Videos',
      para: 'Access expert training whenever you need it.'
    },
    {
      img: '../../../assets/platinumPage/cards/3.png',
      head: 'Live, Interactive Webinars',
      para: 'Flexible Monday–Friday evening and weekend sessions to fit any schedule.'
    },
    {
      img: '../../../assets/platinumPage/cards/4.png',
      head: '1,000+ Downloadable Coaching Resources',
      para: 'A robust library of coaching models, case studies, and resources for clients.'
    }
  ];


  goToBilling(): void {
    if (this.isLoading) return;

    this.isLoading = true;
    this.loaderService.show();

    this.commonService.getPackages().subscribe({
      next: (response: any) => {
        if (response.status === 1 && Array.isArray(response.data)) {

          // 🔥 Find Platinum Package (using includes like Gold)
          const platinumPkg = response.data.find(
            (p: any) => p.name?.toLowerCase().includes('platinum')
          );

          if (!platinumPkg) {
            console.error('Platinum package not found', response.data);
            this.toastService.showError('Platinum package is not available at the moment.');
            this.finishLoading();
            return;
          }

          // 🔥 Apply exact same pricing logic as Package Selection
          const priceDisplay =
            platinumPkg.price === 0 ? 'Custom Pricing' : `$${platinumPkg.price}`;

          // 🔥 Redirect to billing page with correct query params
          this.router.navigate(['/billing-form'], {
            queryParams: {
              packageId: platinumPkg._id,
              package: platinumPkg.name,
              price: priceDisplay,
              installment: platinumPkg.installmentExist === true
            }
          });
        } else {
          console.error('Unexpected API response', response);
          this.toastService.showError('Failed to load packages.');
        }

        this.finishLoading();
      },

      error: (err) => {
        console.error('API Error:', err);
        this.toastService.showError('Unable to load packages. Try again.');
        this.finishLoading();
      }
    });
  }

  private finishLoading(): void {
    this.isLoading = false;
    this.loaderService.hide();
  }
}
